import React, { useContext, useState } from "react";
import { TransactionUpdateDocuments } from "../../../Services/Transactions";
import { Button } from "../../../Components/Base";
import { Toast } from "../../../Utils";
import { ProfileContext } from "../../../Context";

const UserDocuments = () => {
  const { profile, getProfile } = useContext(ProfileContext);
  // ==============================================================================================================================

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [federationMembershipCard, setFederationMembershipCard] =
    useState<File | null>(null);
  const [insuranceCard, setInsuranceCard] = useState<File | null>(null);

  // ==============================================================================================================================

  function formIsValid() {
    return !!federationMembershipCard && !!insuranceCard;
  }

  function handleSubmitForm(e: Event) {
    e.preventDefault();
    if (formIsValid()) {
      setIsLoading(true);
      const form = new FormData();
      form.append("federationMembershipCard", federationMembershipCard!);
      form.append("insuranceCard", insuranceCard!);
      TransactionUpdateDocuments(form)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            Toast("success", res.message);
            getProfile()
          } else {
            Toast("error", res.message);
          }
        })
        .finally(() => setIsLoading(false));
    }
  }

  // ==============================================================================================================================

  return (
    <div className="card border mb-4">
      <div className="card-header border-bottom p-3">
        <h4 className="card-header-title mb-0">کارت فدراسیون و بیمه</h4>
      </div>
      <div className="card-body">
        <div
          className={`d-flex gap-2 input-group mb-3 ${
            isLoading ? "disabled" : ""
          }`}
        >
          <div className="flex-grow-1">
            <div className="col-md-auto text-center text-md-start">
              <div className="avatar avatar-xl mb-2">
                {profile.document.federationMembershipCard ? (
                  <img
                    className="avatar-img rounded-circle border border-white border-3 shadow"
                    src={profile.document.federationMembershipCard}
                    alt="federationMembershipCard image"
                  />
                ) : (
                  <span className="d-flex justify-content-center align-items-center avatar-img rounded-circle border border-white border-3 shadow">
                    <i className="fa opacity-25 fs-2 fa-credit-card" />
                  </span>
                )}
              </div>
            </div>
            <div>
              <label htmlFor="formFile" className="form-label">
                کارت فدراسیون
              </label>
              <input
                className="form-control"
                type="file"
                id="formFile"
                onChange={(e) =>
                  e.target.files
                    ? setFederationMembershipCard(e.target.files[0])
                    : null
                }
              />
            </div>
          </div>
          <div className="flex-grow-1">
            <div className="col-md-auto text-center text-md-start">
              <div className="avatar avatar-xl mb-2">
                {profile.document.insuranceCard ? (
                  <img
                    className="avatar-img rounded-circle border border-white border-3 shadow"
                    src={profile.document.insuranceCard}
                    alt="insuranceCard image"
                  />
                ) : (
                  <span className="d-flex justify-content-center align-items-center avatar-img rounded-circle border border-white border-3 shadow">
                    <i className="fa opacity-25 fs-2 fa-credit-card" />
                  </span>
                )}
              </div>
            </div>
            <div>
              <label htmlFor="formFile" className="form-label text-center">
                کارت بیمه
              </label>
              <input
                className="form-control"
                type="file"
                id="formFile"
                onChange={(e) =>
                  e.target.files ? setInsuranceCard(e.target.files[0]) : null
                }
              />
            </div>
          </div>
        </div>
        <Button
          text="ذخیره"
          onClick={handleSubmitForm}
          isLoading={isLoading}
          disabled={!formIsValid()}
          btnClass="btn w-100 btn-primary"
        />
      </div>
    </div>
  );
};

export default UserDocuments;
